module.exports = __webpack_public_path__ + "static/media/power-ranking-menu-active-icon.e01f4178.svg";